<div>
    <form [formGroup]="formGroup()">
        <ng-template matStepLabel>{{
            "event_steps.step_details.label" | translate
            }}</ng-template>
        <div>
            <h2>{{ "event_steps.step_details.data_header" | translate }}</h2>
            @if (!linkedEvent()) {
            <!-- Titel veld -->
            <mat-form-field appearance="outline" class="size-s">
                <mat-label>{{
                    "event_steps.step_details.titel_label" | translate
                    }}</mat-label>
                <input id="title" #titel matInput formControlName="titel"
                    [placeholder]="'event_steps.step_details.titel_placeholder' | translate" required />
                <mat-hint>{{ titel.value?.length || 0 }} / 150</mat-hint>
                <mat-error>{{
                    "event_steps.step_details.titel_validation" | translate
                    }}</mat-error>
            </mat-form-field>
            }
            <!-- Beschrijving veld -->
            <mat-form-field appearance="outline" class="size-m">
                <mat-label>{{
                    "event_steps.step_details.description_label" | translate
                    }}</mat-label>
                <textarea id="description" #description required maxlength="5000" autosize rows="3" minRows="3"
                    maxRows="10" formControlName="beschrijving" matInput [placeholder]="
                        'event_steps.step_details.description_placeholder' | translate
                      "></textarea>
                <mat-hint>{{ description.value?.length || 0 }} / 5000</mat-hint>
                <mat-error>{{
                    "event_steps.step_details.description_validation" | translate
                    }}</mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="size-s">
                <mat-label>{{
                    "event_steps.step_details.date_label" | translate
                    }}</mat-label>
                <input [min]="minDate" [max]="maxDate" type="datetime-local" matInput name="created"
                    formControlName="created" required />
                <mat-error>{{
                    "event_steps.step_details.date_validation" | translate
                    }}</mat-error>
            </mat-form-field>

            <button 
                class="ai-text-suggestion-button"
                type="button"
                mat-flat-button
                [disabled]="(!formGroup().get('titel')?.value && !linkedEvent)
                            || !formGroup().get('beschrijving')?.value
                            || isLoadingAiSuggestions()"
                (click)="getTextSuggestion()"
            >
                {{ isLoadingAiSuggestions() ? `${("general.generating" | translate )}...`: ("event_steps.step_details.ai_text_suggestion" | translate) }}
            </button>
        </div>
    </form>
</div>